import { call, takeLatest, put, all, delay } from 'redux-saga/effects';
import {
    GET_PRESIGNED_URL,
    GET_REQUEST_STATE,
    UPDATE_REQUEST_STATE,
    GET_URL_BY_KEY,
    savePreSignedURL,
    saveRequestState
} from './actions';
import { api } from '../utils/api';
import { uploadFile } from './upload'
import { baseURL } from '../utils/config'
import { convertToBinary, handleError } from '../utils/helper';
import { setLoaderVisibility } from './ActivityLoader/actions';
import history from '../utils/history';
import { isObject } from 'lodash';

function* fetchPreSignedURL(file) {
    try {
        const response = yield call(api, {
            method: 'GET',
            url: baseURL + 'client/tempCredentials',
            headers: {
                'X-File-Extension': file.type.split('/').pop(),
                'X-File-Content-Type': file.type
            }
        });
        return response.data
    } catch (error) {
        return {}
    }
}

function* uploadFileToSignedURL(url, file) {
    // const formData = new FormData();
    // formData.append("file", file);
    try {
        const response = yield call(api, {
            method: 'PUT',
            url: url,
            body: file,
            headers: {
                'Content-Type': file.type
            }
        });
        return true
    } catch (error) {
        return false
    }
}

function* fetchRequestState({ body }) {
    try {
        yield put(setLoaderVisibility(true));
        const response = yield call(api, {
            method: 'GET',
            url: baseURL + 'client/state',
            body,
        });
        yield put(setLoaderVisibility(false));
        yield put(saveRequestState(response.data || {}));
    } catch ({ response: { data } }) {
        handleError(data)
        yield put(setLoaderVisibility(false));
        yield put(saveRequestState({}));
    }
}

function* updateRequestState({ body }) {
    let { upload, state, data, nextRoute } = body
    try {
        yield put(setLoaderVisibility(true));
        if ((upload || []).length) {
            let convertedFiles = yield all(upload.map(item => call(convertToBinary, data[item])))
            let tempCredentials = []
            for (const index in upload) {
                const response = yield call(fetchPreSignedURL, convertedFiles[index])
                tempCredentials.push(response)
            }
            const response = yield all(upload.map((item, index) => call(uploadFile, tempCredentials[index], convertedFiles[index])))
            let message = ''
            response.forEach((item, index) => {
                if (isObject(item)) {
                    message = item.message
                    return
                }
                else if (!item) {
                    message = 'Unable to upload. Please try again'
                    return
                }
            })
            if (message) {
                handleError({ message })
                yield put(setLoaderVisibility(false));
                return
            }
            upload.forEach((item, index) => {
                data[item] = tempCredentials[index].objectKey.split("/")[2]
            })
        }

        delete body.upload
        delete body.nextRoute
        const response = yield call(api, {
            method: 'POST',
            url: baseURL + 'client/state',
            body,
        });
        yield put(setLoaderVisibility(false));
        yield put(saveRequestState(response.data || {}));
        yield call(history.push, nextRoute);
    } catch (e) {
        console.log(e)
        // handleError()
        yield put(setLoaderVisibility(false));
    }
}

function* fetchURLByKey({ body }) {
    let { key, callback } = body
    try {
        const response = yield call(api, {
            method: 'GET',
            url: baseURL + 'client/url/' + key,
            body,
        });
        yield put(callback(response.data.url))
    } catch (error) {
        yield put(callback(''))
    }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* watchSharedSaga() {
    yield takeLatest(GET_PRESIGNED_URL, fetchPreSignedURL)
    yield takeLatest(GET_URL_BY_KEY, fetchURLByKey)
    yield takeLatest(GET_REQUEST_STATE, fetchRequestState)
    yield takeLatest(UPDATE_REQUEST_STATE, updateRequestState)

}